const localization = {
  unreadLabel: 'Unread',
}

export default localization
